import { EntityReferences } from "../models/mappers";
import { EntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const hubInvitationFields = [
  "gaming_hubinvitationid", // UID
  "gaming_firstname", // Text
  "gaming_lastname", // Text
  "gaming_jobtitle", // Text
  "emailaddress", // Email
  "gaming_accesslevel", // Choice
  "gaming_invitationstatus", // Choice
  "gaming_expireson", // Date
  "gaming_invitationsentdate", // Date
  "gaming_resendinvitationrequestdate", // Date
  "gaming_acceptedon", // Date
  "gaming_AccountId", // Lookup - account
  "gaming_InvitedByContactId", // Lookup - contact
  "gaming_HubLastUpdateByContactId", // Lookup - contact
  "statecode", // State - Active/Inactive
  "statuscode", // Status Reason
] as const;

export const hubInvitationReferences: EntityReferences<EntityName.gaming_hubinvitation> = {
  [EntityName.account]: ["gaming_AccountId"],
  [EntityName.contact]: ["gaming_InvitedByContactId", "gaming_HubLastUpdateByContactId"],
};

export const hubInvitationKey: AnyEntityField<EntityName.gaming_hubinvitation> =
  "gaming_hubinvitationid";
